import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import GlobalConfiguration from './GlobalConfiguration/GlobalConfiguration';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <GlobalConfiguration>
      <App />
    </GlobalConfiguration>
  </React.StrictMode>,
);

reportWebVitals();
